import { render, staticRenderFns } from "./OverviewTable.vue?vue&type=template&id=63e63d95&scoped=true&"
import script from "./OverviewTable.vue?vue&type=script&lang=ts&"
export * from "./OverviewTable.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTable.vue?vue&type=style&index=0&id=63e63d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e63d95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e63d95')) {
      api.createRecord('63e63d95', component.options)
    } else {
      api.reload('63e63d95', component.options)
    }
    module.hot.accept("./OverviewTable.vue?vue&type=template&id=63e63d95&scoped=true&", function () {
      api.rerender('63e63d95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/OverviewTable.vue"
export default component.exports